export const columnsToExport = [
  'stowage',
  'booking',
  'contenedor',
  'armador',
  'iso',
  'tipo',
  'tamano',
  'destino1',
  'nombreDestino',
  'statusOut',
  'toneladas',
  'imos',
  'uns',
  'temperatura',
  'ventilacion',
  'precinto1',
  'precinto2',
  'precinto3',
  'precinto4',
  'mercaderia',
  'destinoFinal',
];
